import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'y42-scrollbar-wrapper',
  templateUrl: './scrollbar-wrapper.component.html',
  styleUrls: ['./scrollbar-wrapper.component.scss'],
})
export class ScrollbarWrapperComponent implements OnChanges, AfterViewInit {
  @Input() arrowLeft = 0;
  @Input() arrowRight = 0;
  @Input() padding = 0;
  @Input() widthUpdated = false;
  childWidth = 0;
  @Input() scrollSize = 0;
  parentWidth = 0;
  maxScroll = 0;
  scrollPosition = 0;

  @ViewChild('scrollbarWrapper', { static: true }) scrollbarWrapper?: ElementRef;
  @ViewChild('content', { static: true }) content?: ElementRef;

  ngOnChanges() {
    setTimeout(() => {
      this.getWidthAndScroll();
    }, 150);
  }

  ngAfterViewInit() {
    this.getWidthAndScroll();
    if (!this.scrollSize) {
      this.scrollSize = this.childWidth ? this.childWidth * 0.2 : 160;
    }
  }

  onScroll(event: Event) {
    this.scrollPosition = (event.target as Element)?.scrollLeft;
  }

  getWidthAndScroll() {
    this.childWidth = this.scrollbarWrapper?.nativeElement.scrollWidth || 0;
    this.scrollSize = this.childWidth * 0.2;
    this.parentWidth = this.scrollbarWrapper?.nativeElement.offsetWidth || 0;
    this.maxScroll = this.childWidth - this.parentWidth - this.padding;
  }

  moveScroll(forward: boolean) {
    // this.maxScroll = this.childWidth - this.padding - this.parentWidth;
    let newPosition = this.scrollPosition;
    if (forward) {
      newPosition += newPosition + this.scrollSize <= this.maxScroll ? this.scrollSize : this.maxScroll - newPosition;
    } else {
      newPosition = newPosition - this.scrollSize >= 0 ? newPosition - this.scrollSize : 0;
    }
    if (this.scrollbarWrapper) {
      this.scrollbarWrapper.nativeElement.scrollLeft = newPosition;
    }
  }

  onResize() {
    this.getWidthAndScroll();
  }
}
